import { z } from "zod";
import { LIMITS } from "./limits";

/** Links in updates must be web links. No javascript:, data: or relative paths. */
export const httpsUrlSchema = z.url({ protocol: /^https$/ }).max(2_000);

/** A short note from Orla for "What I've been up to". Plain text, optionally one link. */
export const updateSchema = z.object({
  id: z.string().min(1),
  body: z.string().trim().min(LIMITS.updateBody.min).max(LIMITS.updateBody.max),
  link: z
    .object({
      url: httpsUrlSchema,
      label: z.string().trim().min(LIMITS.linkLabel.min).max(LIMITS.linkLabel.max),
    })
    .nullable(),
  createdAt: z.iso.datetime(),
});

export const updateCreateSchema = z.strictObject({
  body: updateSchema.shape.body,
  link: updateSchema.shape.link.optional(),
  status: z.enum(["draft", "published"]).default("published"),
});

/** Visibility belongs to the publisher; the public update shape stays unchanged. */
export const adminUpdateSchema = updateSchema.extend({
  status: updateCreateSchema.shape.status,
});

export const updatePatchSchema = z.strictObject({
  status: z.enum(["draft", "published"]),
});

export type Update = z.infer<typeof updateSchema>;
export type AdminUpdate = z.infer<typeof adminUpdateSchema>;
export type UpdateCreate = z.infer<typeof updateCreateSchema>;
export type UpdatePatch = z.infer<typeof updatePatchSchema>;
